import { store } from "../../store";
import subscribeToCoreUpdates from "../core_updates_channel";

let unsubscribeDashboard = null; // store the unsubscribe function

export const initializeDashboardSubscription = () => {
  if (unsubscribeDashboard) return; // already subscribed

  // Provide a unique module key "dashboard"
  unsubscribeDashboard = subscribeToCoreUpdates("dashboard", {
    "dashboard.metrics.updated": (data) => {
      //console.log("📡 dashboard.metrics.updated:", data.metrics);

      store.dispatch({
        type: "dashboard/fetchMetrics/fulfilled",
        payload: data.metrics,
      });
    },
  });

 // console.log("✅ Dashboard subscription initialized");
};

export const unsubscribeDashboardSubscription = () => {
  if (unsubscribeDashboard) {
    unsubscribeDashboard(); // remove only dashboard handlers
    unsubscribeDashboard = null;
    //console.log("🔌 Dashboard subscription removed");
  }
};